// extracted by mini-css-extract-plugin
module.exports = {"container":"jgp-3un35","avatarCharityName":"jgp-ADxc1","pageOwnerSummary":"jgp-25wZh"};